import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { password });
      sessionStorage.setItem("admin_token", res.data.token);
      toast.success("Welcome to the admin dashboard!");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(
        err.response?.status === 401
          ? "Invalid password"
          : "Login failed. Try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4">
      <div className="w-full max-w-sm animate-fade-up">
        <button
          data-testid="admin-back-home"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-stone-500 hover:text-[#EA580C] font-body text-sm mb-8 transition-colors"
        >
          <ArrowLeft className="h-4 w-4" /> Back to Home
        </button>

        <div className="bg-white rounded-2xl border border-stone-100 p-8 shadow-[0_4px_24px_rgb(0,0,0,0.05)]">
          <div className="text-center mb-6">
            <div className="w-14 h-14 rounded-full bg-[#78350F] flex items-center justify-center mx-auto mb-4">
              <Lock className="h-6 w-6 text-[#FED7AA]" />
            </div>
            <h1 className="font-heading text-2xl font-bold text-[#78350F]">
              Admin Access
            </h1>
            <p className="font-body text-sm text-stone-500 mt-1">
              Enter your password to manage the menu
            </p>
          </div>

          <form onSubmit={handleLogin} className="space-y-4">
            <div className="space-y-2">
              <Label className="font-body text-sm text-stone-600">
                Password
              </Label>
              <Input
                data-testid="admin-password-input"
                type="password"
                placeholder="Enter admin password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-white border-stone-200 focus:border-[#EA580C] focus:ring-[#EA580C]/20 rounded-xl h-11 font-body"
                autoFocus
              />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-btn"
              disabled={loading || !password}
              className="w-full rounded-full bg-[#EA580C] hover:bg-[#C2410C] text-white font-body font-semibold h-11 transition-all active:scale-95 disabled:opacity-50"
            >
              {loading ? "Signing in..." : "Sign In"}
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
}
